import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { useFormikContext } from "formik";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getCustomerMasterDataAPI } from "../../../../../services/sales/customerService";
import MapPlaces from "../../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../../partials/content/DialogLayout";
const SoAddress = ({
  customerAddresses = [],
  addressType = "",
  customerAddressDefault = false,
  onCustomerAddressDefault,
}) => {
  let title = "";
  switch (addressType) {
    case "soBilling":
      title = "Billing";
      break;
    case "soDelivery":
      title = "Shipping";
      break;
    default:
      title = "";
      break;
  }
  const { values, setFieldValue } = useFormikContext();
  const [addressOptions, setAddressOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  useEffect(() => {
    function getCustomerMasterData() {
      getCustomerMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { countries } = data;
        setAddressData(customerAddresses, countries);
      });
    }
    getCustomerMasterData();
  }, [customerAddresses]);
  return (
    <React.Fragment>
      <Card>
        <Card.Header>
          <i className="fas fa-map-marked-alt"></i>
          <span>
            <strong>{title} Address</strong>
          </span>
        </Card.Header>
        <Card.Body>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Address Name Reference"
                name={`${addressType}AddressID`}
                options={addressOptions}
                onSelectChange={(value) => {
                  const addressValue = value;
                  setFieldValue(`${addressType}AddressID`, addressValue);
                  if (addressValue === 0) {
                    setFieldValue(`${addressType}Address`, {
                      address: "",
                      city: "",
                      province: "",
                      countryCode: "",
                      postalCode: "",
                      addressPhone: "",
                      addressEmail: "",
                    });
                  } else {
                    for (const address of customerAddresses) {
                      if (address.ID === addressValue) {
                        setFieldValue(`${addressType}Address`, {
                          address: address.address,
                          city: address.city,
                          province: address.province,
                          countryCode: address.countryCode,
                          postalCode: address.postalCode,
                          addressPhone: address.addressPhone,
                          addressEmail: address.addressEmail,
                        });
                        break;
                      }
                    }
                  }
                }}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Address"
                name={`${addressType}Address`}
                secondName="address"
                mapsButton
                onMapsClick={() => {
                  setOpenSearchMapPlaces(true);
                }}
              />
              <FormTextField
                label="City"
                name={`${addressType}Address`}
                secondName="city"
              />
              <FormTextField
                label="Province / State"
                name={`${addressType}Address`}
                secondName="province"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Phone Number"
                name={`${addressType}Address`}
                secondName="addressPhone"
              />
              <FormTextField
                label="Email"
                name={`${addressType}Address`}
                secondName="addressEmail"
              />
              <FormTextField
                label="Postal Code"
                name={`${addressType}Address`}
                secondName="postalCode"
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Country"
                name={`${addressType}Address`}
                secondName="countryCode"
                options={countryOptions}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <DialogLayout
        open={openSearchMapPlaces}
        title="Search Address on Maps"
        onCloseDialog={() => {
          setOpenSearchMapPlaces(false);
        }}
        maxWIdth="lg"
        minHeight={true}
      >
        <MapPlaces
          address={
            addressType == "soBilling"
              ? values.soBillingAddress.address
              : addressType == "soDelivery"
              ? values.soDeliveryAddress.address
              : ``
          }
          city={
            addressType == "soBilling"
              ? values.soBillingAddress.city
              : addressType == "soDelivery"
              ? values.soDeliveryAddress.city
              : ``
          }
          province={
            addressType == "soBilling"
              ? values.soBillingAddress.province
              : addressType == "soDelivery"
              ? values.soDeliveryAddress.province
              : ``
          }
          countryCode={
            addressType == "soBilling"
              ? values.soBillingAddress.countryCode
              : addressType == "soDelivery"
              ? values.soDeliveryAddress.countryCode
              : ``
          }
          postalCode={
            addressType == "soBilling"
              ? values.soBillingAddress.postalCode
              : addressType == "soDelivery"
              ? values.soDeliveryAddress.postalCode
              : ``
          }
          onPinLocation={(
            selectedFormattedAddress,
            selectedShortAddressComponents,
            selectedLongAddressComponents,
            selectedAddress,
            selectedCity,
            selectedProvince,
            selectedCountryCode,
            selectedPostalCode
          ) => {
            setFieldValue(`${addressType}Address.address`, selectedAddress);
            setFieldValue(`${addressType}Address.city`, selectedCity);
            setFieldValue(`${addressType}Address.province`, selectedProvince);
            setFieldValue(
              `${addressType}Address.countryCode`,
              selectedCountryCode
            );
            setFieldValue(
              `${addressType}Address.postalCode`,
              selectedPostalCode
            );
            setOpenSearchMapPlaces(false);
          }}
          onCloseDialog={() => {
            setOpenSearchMapPlaces(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function setAddressData(customerAddresses = [], countries = []) {
    let addressOptionsTmp = [];
    let countryOptionsTmp = [];
    addressOptionsTmp.push({
      value: 0,
      label: "No Reference",
    });
    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    if (typeof customerAddresses !== "undefined") {
      customerAddresses.map((customerAddress, index) => {
        addressOptionsTmp.push({
          value: customerAddress.ID,
          label: customerAddress.addressName,
        });

        if (
          customerAddress.addressName === "Main Address" &&
          customerAddressDefault === true
        ) {
          setFieldValue(`${addressType}AddressID`, customerAddress.ID);
          setFieldValue(
            `${addressType}Address.address`,
            customerAddress.address
          );
          setFieldValue(`${addressType}Address.city`, customerAddress.city);
          setFieldValue(
            `${addressType}Address.province`,
            customerAddress.province
          );
          setFieldValue(
            `${addressType}Address.countryCode`,
            customerAddress.countryCode
          );
          setFieldValue(
            `${addressType}Address.postalCode`,
            customerAddress.postalCode
          );
          setFieldValue(
            `${addressType}Address.addressPhone`,
            customerAddress.addressPhone
          );
          setFieldValue(
            `${addressType}Address.addressEmail`,
            customerAddress.addressEmail
          );
          onCustomerAddressDefault();
        }
      });
    }
    setAddressOptions(addressOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }
};

export default SoAddress;
